import React from 'react';

export default props => <svg {...props} />;



// WEBPACK FOOTER //
// ./src/images/icons/IconDefault.jsx